export default __webpack_public_path__ + "static/media/pisces.80890053.png";